export class PreparationConfig {
  prepareGatewayOrders?: boolean = false;
  orderStatusIds?: string[];

  orderStatusIdAfterPicking?: string;
  orderStatusIdAfterPackaging?: string;
  showOrderResumeInPickings?: boolean = false;

  pickingOrderProductBy?: string = 'location';
  pickingOrderProductDesc?: boolean = false;
  pickingOrderProductSortCriteria?: { field: string; desc: boolean }[];

  packagingOrderProductBy?: string = 'name';
  packagingOrderProductDesc?: boolean = false;
  packagingOrderProductSortCriteria?: { field: string; desc: boolean }[];

  packagingOnlyOwnPicked?: boolean = false;
  allowPackagingWithoutPicking?: boolean = false;

  allowPartialPackaging?: boolean = false;
  allowPartialPicking?: boolean = false;

  autoCreateRequiredPackages?: boolean = false;
  requirePackageMaterial?: boolean = false;

  packagingShowNoteInOrderCard?: boolean = false;
  pickingShowNoteInOrderCard?: boolean = false;

  // SMS Configuration
  smsContent?: string = '';
  enableSmsForPositizeOrders?: boolean = false;
  enableSmsForGatewayOrders?: boolean = false;

  showProductImages?: boolean = true;

  constructor() {
    this.orderStatusIds = [];
    this.prepareGatewayOrders = true;
    this.showProductImages = true;
  }
}
